import React from "react";

export interface SvgIconProps extends React.SVGProps<SVGSVGElement> {}

const Heart = ({ className, style, fill, stroke = "white" }: SvgIconProps) => (
    <svg
        width="30"
        height="26"
        viewBox="0 0 30 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
    >
        <path
            d="M26.05 3.76246C25.4116 3.12372 24.6535 2.61702 23.8192 2.27132C22.9849 1.92561 22.0906 1.74768 21.1875 1.74768C20.2844 1.74768 19.3902 1.92561 18.5558 2.27132C17.7215 2.61702 16.9635 3.12372 16.325 3.76246L15 5.08746L13.675 3.76246C12.3854 2.47285 10.6363 1.74835 8.81253 1.74835C6.98874 1.74835 5.23964 2.47285 3.95003 3.76246C2.66041 5.05208 1.93591 6.80117 1.93591 8.62496C1.93591 10.4488 2.66041 12.1978 3.95003 13.4875L5.27503 14.8125L15 24.5375L24.725 14.8125L26.05 13.4875C26.6888 12.849 27.1955 12.091 27.5412 11.2567C27.8869 10.4223 28.0648 9.52807 28.0648 8.62496C28.0648 7.72185 27.8869 6.82759 27.5412 5.99327C27.1955 5.15894 26.6888 4.40091 26.05 3.76246V3.76246Z"
            fill={fill}
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Heart;
